/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeNameDto } from '../../models/employee-name-dto';

export interface EmployeeControllerGetAllEmployees$Params {
  officeIds?: Array<number>;
  initial: boolean;
  sIds?: Array<number>;
}

export function employeeControllerGetAllEmployees(http: HttpClient, rootUrl: string, params: EmployeeControllerGetAllEmployees$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeNameDto>>> {
  const rb = new RequestBuilder(rootUrl, employeeControllerGetAllEmployees.PATH, 'get');
  if (params) {
    rb.query('officeIds', params.officeIds, {});
    rb.query('initial', params.initial, {});
    rb.query('sIds', params.sIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmployeeNameDto>>;
    })
  );
}

employeeControllerGetAllEmployees.PATH = '/api/employee/employee-names';
